import type { Factory } from 'walden-fast/types/mocks';
import type {
  Stat,
  TrendDirection,
  TrendTimeframe,
} from 'walden-fast/types/stats';

const MOCK_STAT: Stat = {
  label: 'Insight',
  value: '100 %',
  trend: {
    percentage: 20,
    direction: 'increase',
    timeframe: 'WoW',
  },
};

export const statFactory: Factory<Stat> = (overrides) => ({
  ...MOCK_STAT,
  value: `${90 + Math.floor(Math.random() * 10)}`,
  trend: {
    percentage: Math.floor(Math.random() * 100),
    direction: ['increase', 'decrease'][
      Math.floor(Math.random() * 2)
    ] as TrendDirection,
    timeframe: ['week', 'month', 'year'][
      Math.floor(Math.random() * 3)
    ] as TrendTimeframe,
  },
  ...overrides,
});
